export default {
  // 配置显示在浏览器标签的title
  title: '掌上温岭——直播',

  // token在Cookie中存储的天数，默认1天
  cookieExpires: 1,

  // 是否使用国际化，默认为false 如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'} 用来在菜单中显示文字
  useI18n: true,

  // api请求基础路径
  baseUrl: {
    // dev: 'http://localhost:8800/index.php/api/',
    dev: 'http://zswl.com/index.php/api/',
    test: 'https://zswl.wlxww.com/api/',
    // test: 'https://zswl.wlxww.com/api/',
    pro: 'https://zswl.wlxww.com/api/'
  },
  staticUrl: {
    dev: 'http://zswl.com',
    test: 'https://zswl.wlxww.com',
    pro: 'https://zswl.wlxww.com'
  },
  // 默认打开的首页的路由name值，默认为home
  homeName: 'home',

  // 需要加载的插件
  plugin: {
    'error-store': {
      // 设为false后不会在顶部显示错误日志徽标
      showInHeader: true,
      // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
      developmentOff: true
    }
  }
}
